import i18n from "i18next";

export const getSiteLanguage = (pathname = '') => (
    pathname.startsWith('/hk') ? 'zh-HK' : 'en'
);

export const getPath = (path) => {
    if (path === '/') {
        return i18n.language === 'zh-HK' ? '/hk' : '/';
    } else {
        return i18n.language === 'zh-HK' ? `/hk${path}` : path;
    }
};

export const getEnglishPath = (currentPath) => {
    if (currentPath.startsWith('/hk/')) {
        return currentPath.replace(/^\/hk/, '');
    } else if (currentPath === '/hk') {
        return '/';
    } else {
        return currentPath;
    }
};

export const getChinesePath = (currentPath) => {
    if (currentPath === '/') {
        return '/hk';
    } else if (!currentPath.startsWith('/hk')) {
        return '/hk' + currentPath;
    } else {
        return currentPath;
    }
};

export const isValidEmail = (email) => {
    // Basic email validation regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export function capitalizeFirstLetter(val) {
    let arr = val.split(" ");
    arr.forEach((element, index )=> {
        arr[index] = String(element).charAt(0).toUpperCase() + String(element).slice(1);
    });
    return arr.join(" ");
}

export const fetchBlogData = async (locale = "en") => {
    try {
        const response = await fetch(
            `https://backend.activikid.hk/api/blogs?populate=*&locale=${locale}`
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        // Transform the data
        return data.data.map(item => ({
            ID_num: item.attributes.ID_num,
            title: item.attributes.title,
            subtitle: item.attributes.subtitle,
            content: item.attributes.content,
            image_url: item.attributes.image_url?.data?.[0]?.attributes?.url
                ? `https://backend.activikid.hk${item.attributes.image_url.data[0].attributes.url}`
                : '',
            tag: item.attributes.tag?.data?.map(tagItem => tagItem.attributes.tag) || [],
            searchName: item.attributes.searchName
        }));

    } catch (error) {
        console.error('Failed to fetch blog data:', error);
        throw error; // Re-throw to handle in component
    }
};

export const fetchPartnerData = async (locale = "en") => {
    try {
        const response = await fetch(
            `https://backend.activikid.hk/api/partners?populate=*&locale=${locale}`
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data.data);
        return data.data.map(item => ({
            id: item.attributes.ID_num,
            name: item.attributes.name,
            image: "https://backend.activikid.hk" + item.attributes.image?.data[0]?.attributes?.url,
            imagebg: "https://backend.activikid.hk" + item.attributes.imagebg?.data[0]?.attributes?.url,
            category: item.attributes.category?.data?.attributes?.category,
            description: item.attributes.description,
        }));

    } catch (error) {
        console.error('Failed to fetch blog data:', error);
        throw error; // Re-throw to handle in component
    }
};